/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import {
	AnalyticsProps,
	CosmosAsset,
	CosmosCard,
	CosmosLink,
	CosmosRichText,
	CosmosTextVariantEnum,
	OptimizedCosmosAssetFragment,
} from "@cosmos/components";

import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { CosmosSearchItem } from "../types";

const resultItemCardStyles = css({
	gap: "eds.dimension.40",
	flexBasis: "100%",
	"&:hover .cosmos-rich-text.heading": {
		color: "eds.text.link.secondary.default",
	},
});

const resultItemCardContentStyles = css({
	paddingBlockStart: "eds.dimension.24",
});

const resultItemCardHeadingStyles = css({
	sm: {
		lineClamp: "2",
		textOverflow: "ellipsis",
		overflow: "hidden",
		alignSelf: "start",
		textAlign: "start",
	},
	overflowWrap: "anywhere",
});

const resultFormattedHrefStyles = css({
	textDecoration: "underline",
	color: "eds.text.link.primary.default",
	overflowWrap: "anywhere",
	sm: {
		textOverflow: "ellipsis",
		overflow: "hidden",
	},
	"&[href]:focus-visible": {
		outlineOffset: "eds.dimension.3",
		outlineStyle: "solid",
		outlineColor: "eds.palette.static.white",
		borderRadius: "eds.dimension.3",
	},
});

const resultItemCardParagraphStyles = css({
	sm: {
		lineClamp: "3",
		textOverflow: "ellipsis",
		overflow: "hidden",
	},
});

export function SearchResultItem({
	asset,
	href,
	title,
	desc,
	formattedHref,
	analytics,
}: CosmosSearchItem & AnalyticsProps): React.JSX.Element {
	const sizedAsset: OptimizedCosmosAssetFragment = {
		...(asset || {}),
		id: asset?.id || "",
		url: asset?.url || "",
		width: 432,
		height: 243,
	};

	return (
		<CosmosCard borderRadius={16} className={cx("result-item-card", resultItemCardStyles)}>
			{asset?.url && (
				<CosmosCard.Thumbnail aspectRatio="16/9">
					<CosmosAsset asset={sizedAsset} />
				</CosmosCard.Thumbnail>
			)}
			<CosmosCard.Content className={resultItemCardContentStyles}>
				<VStack alignItems="stretch" gap="eds.dimension.16">
					<VStack alignItems="stretch" gap="eds.dimension.8">
						<CosmosCard.Link href={href || ""} analytics={analytics} className={resultItemCardHeadingStyles}>
							{<CosmosRichText variant={CosmosTextVariantEnum.headingLG} html={title?.html} />}
						</CosmosCard.Link>
						<CosmosLink href={href || ""} analytics={analytics} className={resultFormattedHrefStyles}>
							<CosmosRichText
								variant={CosmosTextVariantEnum.uiLG}
								color="eds.text.link.primary.default"
								html={formattedHref}
							/>
						</CosmosLink>
					</VStack>
					<CosmosRichText
						variant={CosmosTextVariantEnum.paragraphMD}
						color="eds.text.secondary"
						html={desc}
						className={resultItemCardParagraphStyles}
					/>
				</VStack>
			</CosmosCard.Content>
		</CosmosCard>
	);
}
